export default "__VITE_ASSET__BUrgDsEf__"